import React from 'react';
import useSetScrollRef from 'hooks/useSetScrollRef';
import HeroWrapper from 'shared/hero-wrapper';

import s from './hero.module.scss';

export default function ServicesHero() {
  const hero = useSetScrollRef();
  return (
    <HeroWrapper img="cxn-hero-what-we-do" className={s.hero} ref={hero}>
      <img
        src="/svg/cxn-results-solutions.svg"
        alt="cxn-results-solutions"
        className={s.img}
      />
    </HeroWrapper>
  );
}
